// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ProductType } from '../Instruments/ProductType';
import { OperationType } from '../Trading/OperationType';
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectTradeMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_TRADE);
        this.TradeId = null;
        this.OrderId = null;
        this.Symbol = null;
        // Под нефикс список, для прочих - бери Symbol и не парься
        this.InstrumentID = 0;
        this.AccountId = null;
        this.Amount = 0;
        this.Price = 0;
        this.Comission = 0;
        this.Rebates = 0;
        this.PnL = 0;
        this.Time = null;
        this.BuySell = OperationType.Buy;
        this.Login = null;
        this.Route = null;
        this.ExternalPrice = 0;
        this.Exchange = '';
        this.OrderType = 0;
        this.PositionID = null;
        this.LastPositionAmount = 0;
        this.PositionSide = 0;
        this.OpenCrossPrise = 0;
        this.ExternalTradeId = null;
        this.ExternalOrderId = null;
        // пока только для бтлдера, но надеюсь серв тоже как-нибудь сможет такое слать
        this.IsClosing = false;
        this.CounterOrderID = '';
        this.TradeIdLabel = null;
        this.ComissionInInstrumentQuotingCurrency = null;
        this.PnLInInstrumentQuotingCurrency = null;
        this.AdvancedTradeParams = null;
        // Используется для начисления свопа не на баланс
        // а на pnl (без необходимости не трогать)
        this.Swap = 0;
        this.ProductType = ProductType.General;
        this.InstrumentTradableID = null;
        this.ExecutionVenue = null;
        this.Leverage = null;
    }
    get ComissionCrossPrice() {
        return this.Comission * this.OpenCrossPrise;
    }
    get RebatesCrossPrice() {
        return this.Rebates * this.OpenCrossPrise;
    }
    get PnLCrossPrice() {
        return this.PnL * this.OpenCrossPrise;
    }
}
// для дополнительных параметров, которые присылает вендор
export class AdvancedTradeParams {
    constructor() {
        // для случая когда коммиссия приходит в различной валюте
        // (обычно либо в валюте аккаунта, либо в валюте котирования)
        this.CommissionAssetID = null;
    }
}
